import { SM_VIEWPORT } from '@constants/viewport';
import { useWindowSize } from '@hooks/use-window-size';
import classNames from 'classnames';

import { ChannelSection } from './channel-section';
import { TeamChannelSectionProps } from './team-channel-section.type';
import { TeamChannelProvider } from './team-channel-section-context';
import { TeamSection } from './team-section';

export const TeamChannelSection = ({
  value,
  onChange,
  errors,
  canCloseSales = true,
  labelClassName,
}: TeamChannelSectionProps) => {
  const isMobileViewPort = useWindowSize(SM_VIEWPORT);

  return (
    <TeamChannelProvider value={value} onChange={onChange} errors={errors}>
      <div className={classNames({ 'ml-1.5': !isMobileViewPort }, 'flex flex-col gap-4')}>
        {value.teams.map((team) => (
          <TeamSection
            key={`teams-${team.id}`}
            team={team}
            isMobileViewPort={isMobileViewPort}
            canCloseSales={canCloseSales}
            labelClassName={labelClassName}
          />
        ))}
        {value.channelsWithoutTeams.map((channel) => (
          <ChannelSection
            key={`channels-${channel.channel.id}`}
            channel={channel}
            isMobileViewPort={isMobileViewPort}
            canCloseSales={canCloseSales}
            labelClassName={labelClassName}
          />
        ))}
      </div>
    </TeamChannelProvider>
  );
};
